import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/initiatives/DesignBlocks";
//import Pages from "pages/Presentation/initiatives/Pages";
//import Testimonials from "pages/Presentation/initiatives/Testimonials";
//import Download from "pages/Presentation/initiatives/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";
import React, { useState, useEffect } from "react";
import { useMutation } from "@apollo/client";
import { ALL_INITIATIVES, LOCK_INITIATIVE, DELETE_INITIATIVE } from "../queries";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// Images
import bgImage from "assets/images/strategia.jpg";
import { useTranslation } from "react-i18next";
import { useQuery } from "@apollo/client";
/* eslint-disable react/prop-types */
const Initiativesadmin = ({ setError }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //Tähän uuden parametrin count lisääminen valitut arrayhin sen arvoksi maarat arraystä saman initiativeid:n parametrin occurrences arvo
  const [initiatives, setInitiatives] = useState([]);
  const [t] = useTranslation("common");
  const initiativess = useQuery(ALL_INITIATIVES, {
    pollInterval: 1000000,
  });
  useEffect(() => {
    let initiativesss = [];
    //let municipalitiess = [];
    if (initiativess.data) {
      initiativesss = initiativess.data.allInitiatives;
      //setOrgans(organss);
      //console.log(initiativesss);
      setInitiatives(initiativesss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [initiativess]);
  const [lockInitiative] = useMutation(LOCK_INITIATIVE, {
    refetchQueries: [{ query: ALL_INITIATIVES }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addinitiative)
    }*/
  });

  const [deleteInitiative] = useMutation(DELETE_INITIATIVE, {
    refetchQueries: [{ query: ALL_INITIATIVES }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addinitiative)
    }*/
  });
  const setLocked = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    lockInitiative({
      variables: { id: event, active: false },
    });
    //muutetaan activated !actived edituser
  };
  const setUnlocked = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    lockInitiative({
      variables: { id: event, active: true },
    });
    //muutetaan activated !actived edituser
  };

  const setDelete = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    deleteInitiative({
      variables: { id: event },
    });
    //muutetaan activated !actived edituser
  };
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="black"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Aloitteet Admin{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="black"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              <h2>{t("headers.initiatives")}</h2>
              <div>
                {initiatives.map((ini) => (
                  <>
                    <Link to={`/initiatives/${ini.id}`}>{ini.initiativetext}</Link>
                    {ini.organid}
                    <br />
                    <Button
                      style={{
                        backgroundColor: "#07575B",
                        color: "#C4DFE6",
                        fontSize: "14px",
                      }}
                      size="small"
                      type="submit"
                      onClick={() => setUnlocked(ini.id)}
                    >
                      {t("common.unlock")}
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#07575B",
                        color: "#C4DFE6",
                        fontSize: "14px",
                      }}
                      size="small"
                      type="submit"
                      onClick={() => setLocked(ini.id)}
                    >
                      {t("common.lock")}
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#07575B",
                        color: "#C4DFE6",
                        fontSize: "14px",
                      }}
                      size="small"
                      type="submit"
                      onClick={() => {
                        if (window.confirm("Haluatko varmasti poistaa aloitteen?")) {
                          setDelete(ini.id);
                        }
                      }}
                    >
                      {t("common.delete")}
                    </Button>
                    <br />
                    <br />
                  </>
                ))}
              </div>
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default Initiativesadmin;
